import { all } from 'redux-saga/effects';
import adminSaga from './adminSaga';
import comicSaga from './comicSaga';
import chapterSaga from './chapterSaga';
import genreSaga from './genreSaga';
import userSaga from './userSaga';

function* rootSaga() {
  yield all([
    adminSaga(),
    comicSaga(),
    chapterSaga(),
    genreSaga(),
    userSaga()
  ]);
}
export default rootSaga;

